import { supabase } from './supabase';
import { emailService } from './email';

export interface MaintenanceRequestPayload {
  productDescription: string;
  issueDescription: string;
  urgency: string;
  preferredContact: string;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
}

export const serviceRequestsService = {
  async submitMaintenanceRequest(
    userId: string,
    payload: MaintenanceRequestPayload,
    userEmail?: string
  ): Promise<{ data: { id: string; type: string } | null; error: string | null }> {
    try {
      const { data, error } = await supabase
        .from('service_requests')
        .insert({
          user_id: userId,
          type: 'maintenance',
          status: 'pending',
          details: {
            issueDescription: payload.issueDescription,
            urgency: payload.urgency,
            productDescription: payload.productDescription,
            preferredContact: payload.preferredContact,
            contactName: payload.contactName,
            contactPhone: payload.contactPhone,
            contactEmail: payload.contactEmail,
          },
        })
        .select('id, type')
        .single();

      if (error) {
        console.error('Maintenance request insert failed:', error);
        return { data: null, error: error.message };
      }

      if (data && userEmail) {
        await emailService.sendServiceRequestConfirmation(data, userEmail);
      }

      return { data, error: null };
    } catch (err: unknown) {
      console.error('Maintenance request submission error:', err);
      const message = err instanceof Error ? err.message : 'Unknown error';
      return { data: null, error: message };
    }
  },
};
